"use client";
import useClientTranslations from "@casino/client/hooks/useClientTranslations";
import getBadge from "@casino/shared/components/GameBadge/helpers/getBadge";
import {
  GAME_BADGE_TRANSLATION_KEYS,
  type GameCardTranslations,
} from "@casino/shared/components/GameCard/translations";
import type { CardThumbnailBadge } from "@workspace/frontend-ui";

const useBadge = (
  game: GameFragment,
  initialTranslations?: GameCardTranslations,
  enabled = true,
): CardThumbnailBadge | null => {
  const badge = getBadge(game);
  const translations = useClientTranslations(
    GAME_BADGE_TRANSLATION_KEYS,
    initialTranslations,
    { enabled },
  );

  if (!badge) return null;

  return {
    label: translations?.[badge.translationKey] ?? "",
    color: badge.color,
    gradient: badge.gradient,
  };
};

export default useBadge;
